import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import { useTranslation } from 'hooks/use-translation';
import useAnchor from 'hooks/useAnchor';
import React, { FC, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';

const GlobalOnlineSchoolSection: FC = () => {
	const { t, transData, list } = useTranslation('home.school');
	const ListRender = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item) => {
			return (
				<div className={styles['li-item']} key={item.id}
				>
					<div className={styles['li-content']} >
						<p>{item.content}</p>
					</div>
				</div>
			)
		})
	}, [list])
	const listImg = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item, index) => {
			return (
				<div className={classnames(styles[`ac-school-img`], styles[`ac-school-img-${item.id}`])} key={index}>
					<img src={item.img} alt="" loading='lazy' />
				</div>
			)
		})
	}, [list])

	useAnchor()


	return (
		<section className={styles['ac-school']} id='school'>
			<div className={styles['ac-school-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title.h1 }}></div>
				<AcSwipe className={classnames(styles['ac-school-banner'], 'ac-school-banner')}
					loop={true}
					slidesPerView={1}
					spaceBetween={32}
					pagination={{ clickable: true, }}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
				>{ListRender}</AcSwipe>
				<div className={styles['ac-school-img-wrap']}>
					{listImg}
				</div>
			</div>
		</section>
	);
}

export default GlobalOnlineSchoolSection
